import PlcNotifications from '../../../base/menu/airdome/PlcNotifications';

const plcNotifications: PlcNotifications = {
  categoryName: 'PLC Notifications',
  current: 'Current',
  archive: 'Archive'
};

export default plcNotifications;
